import React from "react";
import styles from "./ticketTile.module.scss";
import MessageIcon from "@mui/icons-material/Message";
import { getObjectFromArrayOfObjects } from "../../../utils/common/CommonFunctions";
import { connect } from "react-redux";
import PROFILE_PIC from "../../../assets/images/profileImg.png";

const TicketTile = ({
  data,
  onClick,
  selectedTicket,
  customers,
  unreadCount,
}) => {

  console.log("data",data)
  const handleClick = (item) => {
    onClick(item);
  };

  const formatDate = (inputDate) => {
    // Convert to Date object
    const dateObj = new Date(inputDate);

    // Format as dd-mm-yyyy
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = dateObj.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  };

  const getImage = (userId) => {
    const imageUrl = getObjectFromArrayOfObjects(
      customers,
      "id",
      userId
    )?.imageUrl;
    return imageUrl || PROFILE_PIC;
  };

  const getTicketStatus = (status) => {
    switch (status) {
      case 0:
        return { bg: "#C8E2FB", clr: "#1976D2", title: "Placed" };
        break;
      case 1:
        return { bg: "#FFC89A", clr: "#D97706", title: "In Progress" };
        break;
      case 2:
        return "";
        break;
      case 3:
        return "";
        break;
      case 4:
        return "";
        break;
      case 5:
        return { bg: "#05966933", clr: " #059669", title: "resolved" };
        break;
      default:
        return { bg: "", clr: "#1447E6", title: "Placed" };
        break;
    }
  };
  return (
    <div className={styles.ticketList} onClick={() => handleClick(data)}>
      <div
        className={`${styles.ticketItem} ${
          selectedTicket?.id == data?.id ? styles.active : ""
        }`}
      >
        <div className={styles.avatar}>
          <img
            src={getImage(data?.submittedUserId)}
            className={styles.avatarImg}
          />
        </div>
        <div className={styles.ticketInfo}>
          <h4 className={styles.title}>Ticket ID {data?.referenceId}</h4>
          <p className={styles.subtitle}>Cart Bundle ID {data?.cartBundleId}</p>
        </div>
        <div className={styles.details}>
          <div className={styles.msgIconWrapper}>
            <div
              className={styles.bedge}
              style={{
                color: getTicketStatus(data?.status)?.clr,
                borderColor: getTicketStatus(data?.status)?.clr,
              }}
            >
              {unreadCount}
            </div>
            <MessageIcon
              style={{ color: getTicketStatus(data?.status)?.clr }}
            />
          </div>
          <span className={styles.date}>{formatDate(data?.submittedOn)}</span>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    customers: state?.customer?.customers,
  };
};

export default connect(mapStateToProps, null)(TicketTile);
